import React from 'react';
import styles from './index.less';

const ComponentLabel = {
  1: '姓名',
  2: '手机号',
  3: '城市'
};
const MessageRetainConsumer = props => {
  const { data = {} } = props;

  const { content = {} } = data;

  // card_status: 卡片状态 1为空白态， 2为完成态
  const { cover_url, title, components, card_data, card_status = 1 } = content;

  return (
    <div className={styles.card}>
      <img src={cover_url} alt='Card Image' className={styles.image} />
      <div className={styles.info}>
        <h2 className={styles.title}>{card_status === 2 ? '用户已填写留资卡' : title}</h2>
        {/* 未填写 */}
        {card_status === 1 &&
          components.map((component, index) => {
            return <p key={index}>{ComponentLabel[component]}: </p>;
          })}
        {/* 已填写 */}
        {card_status === 2 &&
          card_data.map((item, index) => {
            return (
              <p key={index}>
                {item.label}: {item.value}
              </p>
            );
          })}
      </div>
    </div>
  );
};

export default MessageRetainConsumer;
